export type RoundDraft = { theme: string; description: string };
export function nextStart() {
  const date = new Date();
  date.setDate(date.getDate() + 5);
  date.setHours(12, 0, 0, 0);
  return localStart(date);
}
export function localStart(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}
export function planRounds(
  drafts: RoundDraft[],
  start: string,
  submissionDays: number,
  votingDays: number,
  now = Date.now(),
) {
  const date = new Date(start);
  if (
    !Number.isFinite(date.getTime()) ||
    localStart(date) !== start ||
    !Number.isInteger(submissionDays) ||
    submissionDays < 1 ||
    submissionDays > 14 ||
    !Number.isInteger(votingDays) ||
    votingDays < 1 ||
    votingDays > 14
  )
    return [];
  let startsAt = now;
  return drafts.map((draft, index) => {
    if (index > 0) date.setDate(date.getDate() + submissionDays);
    const submissionEndsAt = date.getTime();
    date.setDate(date.getDate() + votingDays);
    const plan = {
      ...draft,
      startsAt,
      submissionEndsAt,
      votingEndsAt: date.getTime(),
    };
    startsAt = plan.votingEndsAt;
    return plan;
  });
}
export function formatDeadline(time: number) {
  return new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(time);
}

export function timeLeft(deadline: number, now = Date.now()) {
  const remaining = deadline - now;
  if (remaining <= 0) return "Deadline reached";
  if (remaining >= 7 * 86400000) return "";
  const days = Math.ceil(remaining / 86400000);
  if (remaining >= 86400000) return `${days} days left!`;
  const hours = Math.ceil(remaining / 3600000);
  if (remaining >= 3600000)
    return `${hours} ${hours === 1 ? "hour" : "hours"} left!`;
  const minutes = Math.ceil(remaining / 60000);
  return `${minutes} ${minutes === 1 ? "minute" : "minutes"} left!`;
}
